export default {
  column: 'Colonne',
  columns: 'Colonnes',
  verbose_column: 'une colonne',
  general_info: 'Informations générales',

  blocks: 'Blocs',
  slide_per_view: '# Diapositive par vue',
  slide_per_group: '# Diapositive par groupe',
  loop_circuit: 'Carrousel en boucle infinie',
  auto_height: 'Hauteur automatique du carrousel',
  auto_play: 'Lecture automatique du carrousel',
};
